import React from "react";

export interface MutedTextProps {
  text: string;
  className?: string;
}

export default function MutedText({
  className = "",
  text,
}: MutedTextProps): React.JSX.Element {
  return <p className={`${className} fe_u_color--muted`}>{text}</p>;
}
